module.exports = __webpack_public_path__ + "static/img/200305.ff49c1e4.png";